import { Attachment } from '@/modules/Upload/types'
import datacentral from '@/utils/axios/datacentral'
import { ContractProcessCreateParams } from '@/modules/Contract/modules/Process/types'

interface SubcontractParams {
    contractID: number
    subcontractID: number
}
interface SubcontractProcessCreateParams extends SubcontractParams {
    data: ContractProcessCreateParams
    attachments: Attachment[]
}
export const getSubcontractProcesses = async ({
    contractID,
    subcontractID,
}: SubcontractParams) => {
    const response = await datacentral.get(
        `/contracts/customers/${contractID}/subcontracts/${subcontractID}/processes`
    )

    return response?.data?.results
}

export const createSubcontractProcess = async ({
    contractID,
    subcontractID,
    data,
    attachments = [],
}: SubcontractProcessCreateParams) => {
    const response = await datacentral.post(
        `/contracts/customers/${contractID}/subcontracts/${subcontractID}/processes`,
        {
            subcontract: data,
            attachments,
        }
    )

    return response?.data?.result
}
